import { useContext } from 'react';
import { AuthContext } from '../utils/auth.js';
import { canUseAdminDevTools } from '../utils/adminUsers.js';
import DevToolbar from './DevToolbar.js';

export default function AdminDevToolbar() {
  const { currentUser } = useContext(AuthContext);

  if (!canUseAdminDevTools(currentUser?.email)) {
    return null;
  }

  return <DevToolbar />;
}
